import store from '@/store'
import { useLazyQuery } from '@vue/apollo-composable';
import * as api from '@/api/okaso-api'


export type SearchMiddleCategoriesCondition = {
  largeCategoryCd?: number;
}

export function useSearchMiddleCategoriesFunc() {

  const getWhere = (condition: SearchMiddleCategoriesCondition) => {
    const where: api.MiddleCategoryWhereInput  = {
      AND: [],
    }

    // 大分類で絞る --------------------
    // let largeCategoryId = condition.largeCategoryId
    // if (!!largeCategoryId) {
    //   where.AND?.push({
    //     largeCategory: {
    //       is: {
    //         id: { equals: largeCategoryId }
    //       }
    //     }
    //   })
    // }
    let largeCategoryCd = condition.largeCategoryCd
    if (!!largeCategoryCd) {
      where.AND?.push({
        largeCategory: {
          is: {
            largeCd: { equals: largeCategoryCd }
          }
        }
      })
    }

    return where
  }

  const {
    load: searchMiddleCategoriesLoad,
    refetch: searchMiddleCategoriesRefetch,
    onResult: searchMiddleCategoriesOnResult,
    onError: searchMiddleCategoriesOnError
  } = useLazyQuery<
    api.MiddleCategoriesQuery,
    api.MiddleCategoriesQueryVariables
  >(api.MiddleCategoriesDocument, undefined)

  const searchMiddleCategoriesFetchOrRefetch = (variables:api.MiddleCategoriesQueryVariables) => {
    searchMiddleCategoriesLoad(api.MiddleCategoriesDocument, variables) || searchMiddleCategoriesRefetch(variables)
  }

  const searchMiddleCategories = ( condition: SearchMiddleCategoriesCondition ) => {
    const where = getWhere(condition)

    // 検索実行
    searchMiddleCategoriesFetchOrRefetch({
      where,
      orderBy: [
        {
          largeCd: {
            sort: api.SortOrder.Asc
          }
        },
        {
          seq: {
            sort: api.SortOrder.Asc
          }
        }
      ]
    })
  }

  return {
    searchMiddleCategories,
    searchMiddleCategoriesOnResult,
    searchMiddleCategoriesOnError
  }
}
